export default __webpack_public_path__ + "static/media/016-tiktok.d485714d.svg";